<script>
export default {
  name: 'IconPencilEdit',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#030309CC',
    },
    opacity: {
      type: Number,
      default: 0.8,
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.125 13.75H1.875C1.61875 13.75 1.40625 13.5375 1.40625 13.2812C1.40625 13.025 1.61875 12.8125 1.875 12.8125H13.125C13.3813 12.8125 13.5938 13.025 13.5938 13.2812C13.5938 13.5375 13.3813 13.75 13.125 13.75Z"
      :fill="color"
      :fill-opacity="opacity"
    />
    <path
      d="M11.8871 2.17504C10.6746 0.962537 9.48712 0.931287 8.24337 2.17504L7.48712 2.93129C7.42462 2.99379 7.39962 3.09379 7.42462 3.18129C7.89962 4.83754 9.22462 6.16254 10.8809 6.63754C10.9059 6.64379 10.9309 6.65004 10.9559 6.65004C11.0246 6.65004 11.0871 6.62504 11.1371 6.57504L11.8871 5.81879C12.5059 5.20629 12.8059 4.61254 12.8059 4.01254C12.8121 3.39379 12.5121 2.79379 11.8871 2.17504Z"
      :fill="color"
      :fill-opacity="opacity"
    />
    <path
      d="M9.7562 7.20625C9.57495 7.11875 9.39996 7.03125 9.2312 6.93125C9.09371 6.85 8.96245 6.7625 8.8312 6.66875C8.72496 6.6 8.59995 6.5 8.4812 6.4C8.4687 6.39375 8.42495 6.35625 8.37495 6.30625C8.1687 6.13125 7.93745 5.90625 7.7312 5.65625C7.71245 5.64375 7.68121 5.6 7.63745 5.54375C7.57495 5.46875 7.46871 5.34375 7.37496 5.2C7.29995 5.10625 7.21245 4.96875 7.1312 4.83125C7.0312 4.6625 6.94371 4.49375 6.8562 4.31875C6.74148 4.07291 6.41882 3.99988 6.22699 4.19171L2.71246 7.70625C2.63121 7.7875 2.55621 7.94375 2.53746 8.05L2.19996 10.4437C2.13746 10.8687 2.25621 11.2687 2.51871 11.5375C2.74371 11.7562 3.0562 11.875 3.39371 11.875C3.4687 11.875 3.54371 11.8687 3.61871 11.8562L6.0187 11.5188C6.13121 11.5 6.28746 11.425 6.36246 11.3437L9.88279 7.82341C10.0708 7.63542 10.0002 7.31196 9.7562 7.20625Z"
      :fill="color"
      :fill-opacity="opacity"
    />
  </svg>
</template>
